<template>
  <v-dialog v-model="showing_round_modal" persistent eager max-width="600">
    <v-card>
      <v-form
        ref="form"
        v-model="round_form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-toolbar
          class="ps-3"
          :color="form_mode === FORM_MODES.ADD ? 'success' : 'warning'"
          ><h3>
            {{ $t("config_round.config_round") }} (
            {{
              form_mode === FORM_MODES.ADD
                ? $t("config.addnew")
                : $t("config.edit")
            }}
            )
          </h3>
        </v-toolbar>
        <hr />
        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-bind:label="$t('config_round.round_name_th')"
                v-model="configRound_round_name_th"
                v-bind:rules="requiredRules"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-bind:label="$t('config_round.round_name_en')"
                v-model="configRound_round_name_en"
                v-bind:rules="requiredRules"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              {{ $t("config_round.round_start_datetime") }}
              <DateSelectCard
                v-model="configRound_round_start_datetime"
                v-bind:rules="requiredRules"
                minDate="2020-01-01"
                :maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              {{ $t("config_round.round_end_datetime") }}
              <DateSelectCard
                v-model="configRound_round_end_datetime"
                v-bind:rules="requiredRules"
                minDate="2020-01-01"
                :maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="form_validate()"
            variant="flat"
            color="indigo-darken-3"
          >
            {{ $t("config.save") }}</v-btn
          >
          <v-btn @click="showing_round_modal = false" variant="outlined">{{
            $t("config.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";
import DateSelectCard from "@/components/info_cards/DateSelect";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "configRoundAddEditDialog",

  props: {
    toggle_loading: Function,
    fetch_rounds: Function,
  },

  data: () => ({
    FORM_MODES,
    // semesters: ["1", "2", "3"],
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "ปริญญาตรี",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],
    form_mode: null,
    round_form_status: null,
    showing_round_modal: false,

      configRound_id: null,
      configRound_round_name_th: null,
      configRound_round_name_en: null,
      configRound_round_start_datetime: null,
      configRound_round_end_datetime: null,

    configRoundRules: [validator.required, validator.thaiYear],
    requiredRules: [validator.required],
  }),

  components: {
    DateSelectCard,
  },

  computed: {
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    getYearsModified,

    open_add_modal: function (configRound_year_id) {
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      this.configRound_year_id = configRound_year_id;
      this.configRound_round_start_datetime = null;
      this.configRound_round_end_datetime = null;
      this.showing_round_modal = true;
    },

    open_edit_modal: function (item) {
      this.form_mode = FORM_MODES.EDIT;
      this.configRound_id = item.ROUND_ID;
      this.configRound_year_id = item.YEAR_ID;
      this.configRound_round_name_th = item.ROUND_NAME_TH;
      this.configRound_round_name_en = item.ROUND_NAME_EN;
      this.configRound_round_start_datetime = new Date(item.START_DATETIME);
      this.configRound_round_end_datetime = new Date(item.END_DATETIME);
      this.showing_round_modal = true;
    },

    form_validate: function () {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },

    add_form_validate: async function () {
      this.$refs.form.validate();
      if (this.round_form_status) {
        this.showing_round_modal = false;
        this.toggle_loading(true);
        console.log(this.configRound_round_start_datetime);
        let response = await configService
          .setRound({
            year_id: this.configRound_year_id,
            round_name_th: this.configRound_round_name_th,
            round_name_en: this.configRound_round_name_en,
            round_start_datetime: this.$dayjs(
              this.configRound_round_start_datetime
            ).format("YYYY-MM-DD 08:30:00"),
            round_end_datetime: this.$dayjs(
              this.configRound_round_end_datetime
            ).format("YYYY-MM-DD 16:30:00"),
          })
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getYears");
        this.$store.dispatch("officerConfig/getRounds");
        if (response && response.status)
          this.$toast.success(this.$t("toast.create_successfully"));
        else this.$toast.error(this.$t("toast.cannot_create"));

        this.toggle_loading(false);
      }
    },

    edit_form_validate: async function () {
      this.$refs.form.validate();
      if (this.round_form_status) {
        this.showing_round_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .setRound({
            round_id: this.configRound_id,
            year_id: this.configRound_year_id,
            round_name_th: this.configRound_round_name_th,
            round_name_en: this.configRound_round_name_en,
            round_start_datetime: this.$dayjs(
              this.configRound_round_start_datetime
            ).format("YYYY-MM-DD 08:30:00"),
            round_end_datetime: this.$dayjs(
              this.configRound_round_end_datetime
            ).format("YYYY-MM-DD 16:30:00"),
          })
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getYears");
        this.$store.dispatch("officerConfig/getRounds");
        if (response && response.status)
          this.$toast.success(this.$t("toast.create_successfully"));
        else this.$toast.error(this.$t("toast.cannot_create"));

        this.toggle_loading(false);
      }
    },
  },
};
</script>
